module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAMCAYAAAC5tzfZAAAABHNCSVQICAgIfAhkiAAAAGNJREFUKJHdjsENgDAMA22JvehmqJNRJjseQCioQN/cL5Yd20CSNEpK+qbYzgamXVg6QttzgA5zADDchCRpaniz7XIcl5Dt0iquA1H3s3kGsO1q3htjzNvNs6Ty7A+yOPlqCVZ440ywFLAWHwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/Sdingdanpingjia.png
// module id = SMc1
// module chunks = 1